import React from 'react';
import paulaImage from '../assets/paula.png'
import camiloImage from '../assets/camilo.png'
const testimonialsData = [
  {
    name: "Paula T., Directora de Innovación",
    opinion: "Me encanta cómo está funcionando nuestro avatar interactivo. Conoce a fondo toda la línea de negocio y se lo explica claramente a los clientes. Es como tener una biblioteca andante que siempre tiene la respuesta. ¡Lo amé!",
    image: paulaImage
  },
  {
    name: "Camilo M., Business Development",
    opinion: "Nuestros clientes sienten que los atiende una persona real, los escucha, genera empatía y responde con naturalidad. Ahora podemos atender más rápido y con mayor eficiencia, lo que nos permite ser mucho más estratégicos.",
    image: camiloImage
  }
];

function Testimonials() {
  return (
    <div className="testimonials">
      <div className="container py-3">
        <h2 className='section-title'>Testimonios</h2>
        <div className="testimonial-list">

          {testimonialsData.map((testimonial, index) => (
            <div className='row mb-3' >
              {index % 2 == 0 ? (
                <>
                  <div key={index} className="testimonial-item col-md-3">
                    <img style={{ width: '100%' }} src={testimonial.image} />
                  </div>
                  <div className="testimonial-item col-md-9" style={{ textAlign: 'left', alignContent: 'space-evenly' }}>
                    <p>"{testimonial.opinion}"</p>
                    <p>-- {testimonial.name}</p>
                  </div>
                </>
              ) : (
                <>
                  <div key={index} className="testimonial-item col-md-9" style={{ textAlign: 'right', alignContent: 'space-evenly' }}>
                    <p>"{testimonial.opinion}"</p>
                    <p>-- {testimonial.name}</p>
                  </div>
                  <div className="testimonial-item col-md-3" >
                    <img style={{ width: '100%' }} src={testimonial.image} />

                  </div>
                </>
              )}

            </div>
          ))}

        </div>
      </div>

    </div>
  );
}

export default Testimonials;